import React from 'react';

const SubstitutePlayerInput = ({
  players,
  movedSubstitutions,
  teamId,
  number,
  substitutions,
  onChange,
}) => {
  const SUBSTITUTIONS_TO_INITIALIZE = 4;

  if (substitutions.length < SUBSTITUTIONS_TO_INITIALIZE) {
    return null;
  }

  players.sort(
    (a, b) =>
      a.firstName.localeCompare(b.firstName, 'et') ||
      a.lastName.localeCompare(b.lastName, 'et')
  );
  movedSubstitutions.sort(
    (a, b) =>
      a.playerFirstName.localeCompare(b.playerFirstName, 'et') ||
      a.playerLastName.localeCompare(b.playerLastName, 'et')
  );

  return (
    <tr>
      <td>
        <input
          type="number"
          name={`subGameNo-${number}`}
          data-id={number}
          data-teamid={teamId}
          id={`subGameNo-${number}`}
          className="substitutionGameNo"
          onChange={onChange}
          value={substitutions[number]?.substitutionGameNo ?? ''}
        />
      </td>
      <td>
        <select
          name={`subPlayerId-${number}`}
          data-id={number}
          data-teamid={teamId}
          id={`subPlayerId-${number}`}
          className="substitutionPlayer"
          onChange={onChange}
          value={substitutions[number]?.substitutionPlayer ?? ''}
        >
          <option value="" />
          {players.map((player) => (
            <option key={`${number}-${player.id}`} value={player.id}>
              {player.firstName} {player.lastName}
            </option>
          ))}
          {movedSubstitutions.map((movedSub) => (
            <option
              disabled
              key={`${number}-${movedSub.substitutionPlayer}`}
              value={movedSub.substitutionPlayer}
            >
              {movedSub.playerFirstName} {movedSub.playerLastName}*
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          type="number"
          name={`subEntered-${number}`}
          data-id={number}
          data-teamid={teamId}
          id={`subEntered-${number}`}
          className="substitutionEntered"
          onChange={onChange}
          value={substitutions[number]?.substitutionEntered ?? ''}
        />
      </td>
    </tr>
  );
};

export default SubstitutePlayerInput;
